import { render, staticRenderFns } from "./Basic.vue?vue&type=template&id=6d3dfefa"
import script from "./Basic.vue?vue&type=script&lang=js"
export * from "./Basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d3dfefa')) {
      api.createRecord('6d3dfefa', component.options)
    } else {
      api.reload('6d3dfefa', component.options)
    }
    module.hot.accept("./Basic.vue?vue&type=template&id=6d3dfefa", function () {
      api.rerender('6d3dfefa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/Basic.vue"
export default component.exports